export const colorCodes = [
    "#E31C79", // pink
    "#BB16A3", // purple
    "#FFA300", // yellow
    "#E87722", // orange
    "#00BFB3", // teal
    "#00A9E0", // blue
    "#97D700", // green
    "#FA4616", // red
];